<template>
  <el-dialog
    title="架构图"
    :visible.sync="dialogVisible"
    top="8vh"
    width="95vw"
    :close-on-click-modal="false" @close="onClose">
    <MeterViewDiagram v-if="dialogVisible&&excel_list2.length>0" :excel_list="excel_list2" />
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">关 闭</el-button>
  </span>
  </el-dialog>
</template>

<script>
import MeterViewDiagram from "../MeterViewDiagram";
export default {
  name: "MeterViewDiagramWindow",
  components: {MeterViewDiagram},
  data(){
    return{
      dialogVisible:false,
      excel_list2:[],
    }
  },
  methods: {
    show(batch_number, number,callback) {
      const that = this;
      ERP.postRequest({
        url: "admin/Meter/getMapCacheTree",
        data: {
          batch_number: batch_number,
          number: number,
        },
      }, ret => {
        typeof callback==="function"&&callback(ret)
        if (ret.code) {
          that.excel_list2 = ret.data;
          that.dialogVisible = true;
        } else {
          that.$message.error(ret.msg || "数据异常")
        }
      })
    },
    onClose() {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/components/MeterViewDiagramWindow.vue